<div class="container">
  <div class="table-controls">
    <div class="row">
      <div class="col-md-4 col-sm-4">
        <input class="form-control"
               #aslInput
               (blur)="onBlurAsl($event)"
               [(ngModel)]="asl"
               [placeholder]="'pages.shipmentReceiving.shipmentScanning.asl' | translate" />
        <div class="toggle-holder">
          <label class="switch">
            <input type="checkbox"
                   (change)="enableAsl()"
                   [checked]="aslEnabled">
            <span class="slider round"></span>
          </label>

        </div>
      </div>
      <div class="col-md-6 col-sm-6">
        <div class="row">
          <div class="col-md-8 col-sm-8">
            
            <input class="form-control" (blur)="onBlur($event)"
                   #scannerInput
                   ngxBarCodePut
                   style="opacity:1"
                   [(ngModel)]="shipmentNumber"
                   (keyup.enter)="scan($event)"
                   (onDetected)="onDetected($event)"
                   [placeholder]="'pages.shipmentReceiving.shipmentScanning.shipmentNumberEnter' | translate">

          </div>
          <div class="col-md-4 col-sm-4">
            <button class="btn btn-primary" style="width:100%" (click)="closeTrip()">{{ 'common.done' | translate}}</button>
          </div>
          <div class="col-md-12 col-sm-12">
            <div *ngIf="showShipmentNotFound" class="alert alert-danger">
              <p>{{errorMessage}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-header">
    <div class="row ">
      <div class="col-md-6 col-xs-6 col-sm-6">
        <h4>{{ 'common.pending' | translate }}</h4>
        <h4>{{penddingShipments.length}}</h4>
        <h4>{{ 'pages.shipmentReceiving.shipments' | translate }}</h4>
      </div>
      <div class="col-md-6 col-xs-6 col-sm-6">
        <h4>{{ 'common.received' | translate }}</h4>
        <h4>{{receivedShipments.length}}</h4>
        <h4>{{ 'pages.shipmentReceiving.shipments' | translate }}</h4>
      </div>

    </div>
  </div>
  <div class="table-body">
    <div class="row">
      <div class="col-md-6 col-sm-6 col-xs-6">

        <div class="row" *ngFor="let shipment of penddingShipments">
          <div class="col-md-12">
            <div class="scanning-card row">
              <div class="col-md-2 col-sm-2 col-xs-2">
                <div class="status green">&nbsp;</div>
              </div>
              <div class="col-md-5 col-sm-5 col-xs-5">
                <div>{{shipment.ShipmentNumber}}</div>
              </div>
              <div class="col-md-5 col-sm-5 col-xs-5">
                <img class="img-responsive" src="/assets/img/barcode2.png"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-6 col-xs-6">
        <div class="row" *ngFor="let shipment of receivedShipments">
          <div class="col-md-12">
            <div class="scanning-card row">
              <div class="col-md-2 col-sm-2 col-xs-2">
                <div class="status green">&nbsp;</div>
              </div>
              <div class="col-md-5 col-sm-5 col-xs-5">
                <div>{{shipment.ShipmentNumber}}</div>
              </div>
              <div class="col-md-5 col-sm-5 col-xs-5">
                <img class="img-responsive" src="/assets/img/barcode2.png" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
